export default {
  data() {
    return {
      holdInterval: null,
      holdTimeout: null
    }
  },
  methods: {
    startHold(action) {
      action()
      this.holdTimeout = setTimeout(() => {
        this.holdInterval = setInterval(action, this.holdRepeatInterval)
      }, this.holdRepeatDelay)
    },
    endHold() {
      clearTimeout(this.holdTimeout)
      clearInterval(this.holdInterval)
      this.holdTimeout = null
      this.holdInterval = null
    }
  },
  beforeUnmount() {
    this.endHold()
  }
}
